import { AggregationSerie } from './aggregation-serie';
import { SearchRequestNg } from './search-request-ng';

export class AggregationRequestNg{
    series: Array<AggregationSerie> = [];
}